exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-select .dropdown-toggle .clear {\n    height: 90%;\n    bottom: 0.1rem;\n}\n.v-select:not(.single) .dropdown-toggle .clear {\n    display: block !important;\n}\n.v-select ul.dropdown-menu li.active,\n.v-select .dropdown-toggle .clear[disabled],\n.v-select .selected-tag .close[disabled] {\n    display: none !important;\n}\n.v-select:not(.single) .selected-tag {\n    background-color: #007bff;\n    color: white;\n    line-height: 1.7rem;\n}\n.v-select .selected-tag .close {\n    height: 100%;\n    float: right;\n    margin-left: 5px;\n    color: white;\n    opacity: 1;\n    font-weight: normal;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-468e18cd","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/SelectCustom.vue
// module id = 558
// module chunks = 0